"use client"

import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Info } from 'lucide-react';

interface InfoTooltipProps {
    content: React.ReactNode;
}

export default function InfoTooltip({ content }: InfoTooltipProps) {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger  aria-label="tooltip">
                    <Info className="size-3 text-ivory/60 cursor-help" />
                </TooltipTrigger>
                <TooltipContent className="bg-oxford/90 text-ivory p-2 text-xs border border-ivory/10">
                    {content}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}